import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data: {},
  message: null

};

export const agreementAcceptFlag = createAsyncThunk(
  "agreementAcceptFlag",
  async (data) => {
    try {
      const response = await fetch(`/api/agreementAcceptFlag/${data.targetStoreHash}`, {
        method: "PUT"
      });
      if (!response.ok) {
        throw new Error("Failed to save the agreement status");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "agreementAcceptFlag",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(agreementAcceptFlag.pending, (state) => {
        state.status = "Agreement accept inprogress";
        state.message = null;
      })
      .addCase(agreementAcceptFlag.fulfilled, (state, action) => {
        state.status = "Agreement accept successful";
        state.data = action.payload.data.data;
      })
      .addCase(agreementAcceptFlag.rejected, (state, action) => {
        state.status = "Agreement accept error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
